import { render, staticRenderFns } from "./NoMessage.vue?vue&type=template&id=d4058ca2&scoped=true"
import script from "./NoMessage.vue?vue&type=script&lang=js"
export * from "./NoMessage.vue?vue&type=script&lang=js"
import style0 from "./NoMessage.vue?vue&type=style&index=0&id=d4058ca2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4058ca2",
  null
  
)

export default component.exports